import { MakeCall } from './createMakeCall';

const logout = (makeCall: MakeCall) => () =>
  makeCall<undefined>('POST', `/api/v2/action/logout`);

export { logout };
